/* eslint-disable @typescript-eslint/no-explicit-any */
/* eslint-disable @typescript-eslint/explicit-module-boundary-types */
import { encodeBase64 } from '../../utils/utilityFunctions';
import { CALL_API } from '../middleware';
import {
  ADAuthenticateRequestBody,
  ADAuthenticateResponseBody,
  GenerateTokenWithRoleRequestBody,
  GenerateTokenWithRoleResponseBody,
  GetInvestorJointHolderDetailsRequestBody,
  GetInvestorJointHolderDetailsResponseBody,
  GetInvestorTokenCompanyRequestBody,
  GetInvestorTokenCompanyResponseBody,
  GetPortalLaunchUrlResponse,
  GetRoleBasedPermissionsRequestBody,
  GetRoleBasedPermissionsResponseBody,
  LoginWithOtpRequestBody,
  LoginWithOtpResponseBody,
  VerifyLoginOtpRequestBody,
  VerifyLoginOtpResponseBody,
} from '../types/api-types';
import {
  AD_AUTHENTICATE,
  AD_AUTHENTICATE_SUCCESS,
  GET_MPOWER_REDIRECT_URL,
  GET_MPOWER_REDIRECT_URL_SUCCESS,
  LOGIN_WITH_OTP,
  LOGIN_WITH_OTP_SUCCESS,
  LOGOUT_SUCCESS,
  VERIFY_LOGIN_OTP,
  VERIFY_LOGIN_OTP_SUCCESS,
  GET_USER_INFO_SUCCESS,
  GET_USER_INFO,
  SHOW_GLOBAL_ERROR,
  LOGOUT,
  GET_JOINT_ACCOUNT_LIST_SUCCESS,
  GET_JOINT_ACCOUNT_LIST_FAILED,
  NEW_VERIFY_LOGIN_OTP_SUCCESS,
  NEW_VERIFY_LOGIN_OTP,
  SET_CORRELATION_ID,
  GET_INVESTOR_JOINT_HOLDER_DETAILS_SUCCESS,
  GET_INVESTOR_JOINT_HOLDER_DETAILS,
  GET_INVESTOR_TOKEN_COMPANY,
  GET_INVESTOR_TOKEN_COMPANY_SUCCESS,
  GENERATE_TOKEN_WITH_ROLE_SUCCESS,
  GENERATE_TOKEN_WITH_ROLE,
  GET_ROLE_BASED_PERMISSIONS_SUCCESS,
  GET_ROLE_BASED_PERMISSIONS,
} from '../types/auth';

export const loginWithOtp =
  (body: LoginWithOtpRequestBody) =>
    async (dispatch: any): Promise<LoginWithOtpResponseBody> => {
      return await dispatch({
        [CALL_API]: {
          url: `/users/login/send-otp`,
          method: 'POST',
          types: [LOGIN_WITH_OTP_SUCCESS, LOGIN_WITH_OTP],
          body: { payload: encodeBase64(JSON.stringify(body)) },
        },
      });
    };

export const verifyLoginOtp =
  (body: VerifyLoginOtpRequestBody) =>
    async (dispatch: any): Promise<VerifyLoginOtpResponseBody> => {
      return await dispatch({
        [CALL_API]: {
          url: `/users/login/verify-otp`,
          method: 'POST',
          types: [VERIFY_LOGIN_OTP_SUCCESS, VERIFY_LOGIN_OTP],
          body: { payload: encodeBase64(JSON.stringify(body)) },
        },
      });
    };
export const newVerifyLoginOtp =
  (body: VerifyLoginOtpRequestBody) =>
    async (dispatch: any): Promise<VerifyLoginOtpResponseBody> => {
      return await dispatch({
        [CALL_API]: {
          url: `/users/login/verify-otp`,
          method: 'POST',
          types: [NEW_VERIFY_LOGIN_OTP_SUCCESS, NEW_VERIFY_LOGIN_OTP],
          body: { payload: encodeBase64(JSON.stringify(body)) },
        },
      });
    };

export const logout = () => {
  return {
    [CALL_API]: {
      url: `/users/users/logout`,
      method: 'POST',
      types: [LOGOUT_SUCCESS, LOGOUT],
    },
  };
};

export const getUserInfo = () => {
  return {
    [CALL_API]: {
      url: `/users/users/me`,
      method: 'GET',
      types: [GET_USER_INFO_SUCCESS, GET_USER_INFO],
    },
  };
};

export const showError = (message: string) => {
  return {
    type: SHOW_GLOBAL_ERROR,
    errorType: 'ALERT',
    message,
  };
};

export const getJointAccountList = () => {
  return {
    [CALL_API]: {
      // url: `/users/users/account-list`,
      enableFixture: true,
      json: 'joint-account-list.json',
      method: 'GET',
      types: [GET_JOINT_ACCOUNT_LIST_SUCCESS, GET_JOINT_ACCOUNT_LIST_FAILED],
    }
  }
};

export const setCorrelationId = (correlationId: string | null) => {
  return {
    type: SET_CORRELATION_ID,
    correlationId,
  };
};

export const getInvestorJointHolderDetails =
  (body: GetInvestorJointHolderDetailsRequestBody) =>
    async (dispatch: any): Promise<GetInvestorJointHolderDetailsResponseBody> => {
      return await dispatch({
        [CALL_API]: {
          url: '/onboarding/dashboard/getInvestorDetails',
          method: 'GET',
          types: [GET_INVESTOR_JOINT_HOLDER_DETAILS_SUCCESS, GET_INVESTOR_JOINT_HOLDER_DETAILS],
          temporaryToken: body?.temporaryToken ?? ""
        },
      });
    };

export const getInvestorTokenCompany =
  (body: GetInvestorTokenCompanyRequestBody) =>
    async (dispatch: any): Promise<GetInvestorTokenCompanyResponseBody> => {
      return await dispatch({
        [CALL_API]: {
          url: '/users/users/generate-investor-token-with-company',
          method: 'POST',
          types: [GET_INVESTOR_TOKEN_COMPANY_SUCCESS, GET_INVESTOR_TOKEN_COMPANY],
          temporaryToken: body?.temporaryToken ?? "",
          body: {
            clientCode: body?.clientCode,
            applicationId: body?.applicationId
          },
        },
      });
    };

export const generateTokenWithRole =
  (body: GenerateTokenWithRoleRequestBody) =>
    async (dispatch: any): Promise<GenerateTokenWithRoleResponseBody> => {
      return await dispatch({
        [CALL_API]: {
          url: '/users/users/generate-token-with-role',
          method: 'POST',
          types: [GENERATE_TOKEN_WITH_ROLE_SUCCESS, GENERATE_TOKEN_WITH_ROLE],
          temporaryToken: body?.temporaryToken ?? "",
          body: {
            role: body?.role ?? ""
          },
        },
      });
    };

export const  getRoleBasedPermissions =
  (body: GetRoleBasedPermissionsRequestBody) =>
    async (dispatch: any): Promise<GetRoleBasedPermissionsResponseBody> => {
      return await dispatch({
        [CALL_API]: {
          url: '/onboarding/amc/getRoleBasedPermissions',
          method: 'GET',
          types: [GET_ROLE_BASED_PERMISSIONS_SUCCESS, GET_ROLE_BASED_PERMISSIONS],
          temporaryToken: body?.temporaryToken ?? "",
        },
      });
    };

export const cyberArcLogin =
  (redirectUri: string) =>
    (): void => {
      // const queryParams = new URLSearchParams({ redirect_uri: redirectUri });
      window.location.href = `api/users/login/cyberarkRedirectionURL`;
    };
    
export const adAuthenticate =
  (body: ADAuthenticateRequestBody) =>
    async (dispatch: any): Promise<ADAuthenticateResponseBody> => {
      return await dispatch({
        [CALL_API]: {
          url: '/users/login/ad-authentication',
          method: 'POST',
          types: [AD_AUTHENTICATE_SUCCESS, AD_AUTHENTICATE],
          body: { payload: encodeBase64(JSON.stringify(body)) },
        },
      });
    };

export const getMpowerRedirectUrl =
  () =>
    async (dispatch: any): Promise<GetPortalLaunchUrlResponse> => {
      return await dispatch({
        [CALL_API]: {
          url: '/onboarding/appLauncher/getMpowerRedirectUrl',
          method: 'GET',
          types: [GET_MPOWER_REDIRECT_URL_SUCCESS, GET_MPOWER_REDIRECT_URL],
        },
      });
    };

